import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { ContentLoader } from '@saucelabs/sl-component-loader';
import { records as userRecords } from '@saucelabs/sl-module-user';
import { useActiveTab } from '@saucelabs/sl-util-helpers';

import * as operations from './../operations';
import ApplicationContentWithLaunchDarkly from './ApplicationContentWithLaunchDarkly';

const Application = (props) => {
  const { initialize, postInitialize, stop, stopPolling, startPolling } = props;

  useEffect(() => {
    const initializeApp = async () => {
      try {
        await initialize();
        postInitialize();
        startPolling();
      } catch (__) {
        //
      }
    };

    void initializeApp();

    return () => {
      stop();
    };
  }, [initialize, postInitialize, startPolling, stop]);

  useActiveTab({
    start: startPolling,
    stop: stopPolling,
    // Disabling auto-poll from this hook, since we should rely on authentication which is handled
    // in the same component
    autoStart: false,
  });

  const { children, initialized, user, errorCode, cordAuthToken } = props;
  const appInitialized = initialized && user;

  return (
    <ContentLoader show={!appInitialized && !errorCode}>
      <ApplicationContentWithLaunchDarkly
        cordAuthToken={cordAuthToken}
        user={user}
      >
        {children}
      </ApplicationContentWithLaunchDarkly>
    </ContentLoader>
  );
};

Application.defaultProps = {
  cordAuthToken: undefined,
  errorCode: undefined,
  user: null,
};

Application.propTypes = {
  children: PropTypes.node.isRequired,
  cordAuthToken: PropTypes.string,
  errorCode: PropTypes.number,
  initialize: PropTypes.func.isRequired,
  initialized: PropTypes.bool.isRequired,
  postInitialize: PropTypes.func.isRequired,
  startPolling: PropTypes.func.isRequired,
  stop: PropTypes.func.isRequired,
  stopPolling: PropTypes.func.isRequired,
  user: ImmutablePropTypes.recordOf(userRecords.UserRecordClass),
};

const mapStateToProps = ({ apps: { app }, user, errorPage }) => ({
  cordAuthToken: app.get('cordToken'),
  errorCode: errorPage.status,
  initialized: app.get('initialized'),
  user,
});

const mapDispatchToProps = {
  initialize: operations.initialize,
  postInitialize: operations.postInitialize,
  stop: operations.stop,
  startPolling: operations.startPolling,
  stopPolling: operations.stopPolling,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Application);

export { Application, mapStateToProps, mapDispatchToProps };
